module.exports = __webpack_public_path__ + "213ba9bdee4311e9f71ab0144c27554b.svg";